import { Col, Row } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import '../i18n';
export function PageNotFound() {
  const { t } = useTranslation();
  return (
    <>
      <div className="dashboard-main-area">
        <div className="dashboard-area">
          <Row className="justify-content-center">
            <Col md={11}>
              <div className="no-found">
                <img src={require("../assets/images/no-found.svg").default} />
                <h2>{t("page_not_found")}</h2>
                <p className="text-center">
                  {t("page_not")}
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
